import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { StatisticsDashboardComponent } from './statistics-dashboard/statistics-dashboard.component';
import { CommonModule } from '@angular/common';
import { StatisticsWorkerAgreementsComponent } from './statistics-worker-agreements/statistics-worker-agreements.component';
import { BaseChartDirective } from 'ng2-charts';
import { Chart } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom'

Chart.register(zoomPlugin);

@NgModule({
  imports: [
    CommonModule, SharedModule, BaseChartDirective
  ],
  declarations: [
    StatisticsDashboardComponent,
    StatisticsWorkerAgreementsComponent
  ],
  providers: [],
  exports: [StatisticsDashboardComponent],
})
export class StatisticsModule { }
